export const PRODUCT_KEYS = {
  IPS: "ips",
  SMARTKID: "smart-kid",
  SIGNATUREULIP: "signature-ulip",
  GIFTPRO: "gift-pro",
  GIFT: "gift",
  IPS_SUPER: "ips-super",
  PNG: "png",
  SIGNATURE_ASSURE: "signature-assure",
  GPP_FLEXI: "gpp-flexi",
  SARAL_PENSION: "saral-pension",
  SIGNATURE_YOUTH: "signature-power-youth",
  SMARTKID_ASSURE: "smart-kid-assure",
  SIP_PLUS: "signature-power-youth",
  CAPITAL_GUARANTEE_II: "capital-guarantee-II",
  IWISH: "iwish",
  OTC_SJB: "otc-sjb",
  SIGNATURE_PENSION: "signature-pension-plan",
  GOLD: "gold",
  PLATINUM: "platinum",
  UNIFIED_PLAN: "unified-plan",
  SMARTKID_360: "smart-kid-360",
  GPP: "gpp",
  ICARE: "icare",
  IPROP: "iprop",
  GIFT_CITY: "gift-city",
  GLOBAL_WEALTH_ACCELERATOR: "wealth-accelerator",
  SIGNATURE_SECURE: "signature-secure",
  PNG_WHOLELIFE: "png-wholelife",
  SAVENGROW: "savengrow",
  SARALJEEVANBIMA: "saral-jeevan-bima",
  FUTUREPERFECT: "future-perfect",
  LTC: "life-time-classic",
};

export const PRODUCT_SHORT_NAME = {
  smartkid: "SmartKid",
  signature: "SIG",
  giftPro: "GIFTPRO",
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: "SigAssure",
  [PRODUCT_KEYS.PNG]: "PNG",
  [PRODUCT_KEYS.GPP_FLEXI]: "GPPFlexi",
  [PRODUCT_KEYS.SARAL_PENSION]: "SaralPension",
  [PRODUCT_KEYS.SIP_PLUS]: "SIP",
  [PRODUCT_KEYS.CAPITAL_GUARANTEE_II]: "SCG",
  [PRODUCT_KEYS.PLATINUM]: "Platinum",
  [PRODUCT_KEYS.GPP]: "Gpp",
  [PRODUCT_KEYS.UNIFIED_PLAN]: "Unified",
  [PRODUCT_KEYS.SIGNATURE_PENSION]: "sign_pension",
  [PRODUCT_KEYS.GOLD]: "Gold",
  [PRODUCT_KEYS.SIGNATURE_SECURE]: "SigSecure",
  [PRODUCT_KEYS.GIFT]: "Gift",
  [PRODUCT_KEYS.IPROP]: "IPROP",
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: "wealth_accelerator",
  [PRODUCT_KEYS.SMARTKID_ASSURE]: "SmartKidAssure",
  [PRODUCT_KEYS.PNG_WHOLELIFE]: "PNGWholelife",
  [PRODUCT_KEYS.SAVENGROW]: "Save And Grow",
  [PRODUCT_KEYS.SARALJEEVANBIMA]: "Saral Jeevan Bima",
  [PRODUCT_KEYS.FUTUREPERFECT]: "Future Perfect",
  [PRODUCT_KEYS.LTC]: "Life Time Classic",
};

export const PLAN_TYPES = {
  LIFE: "Life",
  PNGLIFE: "PNGLIFE",
  IPROP: "IRPR",
  GIFT: "Lump-Sum",
};

export const PRODUCT_CODES = Object.freeze({
  iProtectSmartNew: "T74",
  iProtectSuper: "T72",
  iProtectSmartNewSinglePay: "T75",
  iProtectCare: "T78",
  smartKid: "UA8",
  signature: "UW3",
  giftPro: "E36",
  superIps: "T72",
  png: "UW5",
  sigAssure: "UB9",
  gppFlexi: "I19",
  saralPension: "I16",
  sipPlus: "UC1",
  smartKidAssure: "UB9",
  capitalGuaranteeII: "KP",
  iwish: "T73",
  otc: "T59",
  pngGrowth: "UW8",
  sigPension: "UB8",
  gold: "E35",
  platinum: "UW6",
  smartKid360: "E41",
  gift: "E29",
  iprop: "T70",
  gpp: "I14",
  giftCity: "XU1",
  giftCitySinglePay: "XU0",
  wealthAccelerator: "XU3",
  wealthAcceleratorSinglePay: "XU2",
  sigSecure: "UC5",
  pngWholeLife: "UC4",
});

//Update this array for appointment scheduling
export const PROTECTION_PRODUCTS = [PRODUCT_CODES.iProtectSmartNew, PRODUCT_CODES.iProtectSuper];

export const PRODUCT_KEY = Object.freeze({
  super: "ips-super",
  ips: "ips",
  png: "png",
  gppFlexi: "gpp-flexi",
});

export const LEAD_CODES = Object.freeze({
  [PRODUCT_KEYS.SIGNATUREULIP]: "AW-850515685/Md_WCIDm164BEOWtx5UD",
  [PRODUCT_KEYS.GIFTPRO]: "AW-850485480/_xPUCJXMi88YEOjBxZUD",
  [PRODUCT_KEYS.IPS_SUPER]: "AW-964212897/U4ToCJ66ifYZEKHx4ssD",
  [PRODUCT_KEYS.PNG]: "AW-850515685/qUJ6CLm1-bcYEOWtx5UD",
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: "AW-850515685/EycMCN2Sl_IZEOWtx5UD",
  [PRODUCT_KEYS.GPP_FLEXI]: "AW-850515928/sG6BCN22y5EDENivx5UD",
  [PRODUCT_KEYS.SARAL_PENSION]: "AW-850515928/ThMzCJOS1ZEDENivx5UD",
  [PRODUCT_KEYS.IPS]: "AW-964212897/Pp2BCOniz2EQofHiywM",
  [PRODUCT_KEYS.SIP_PLUS]: "AW-850515685/NIXQCPqiwdEaEOWtx5UD",
  iwish: "iwish",
  [PRODUCT_KEYS.OTC_SJB]: "AW-964212897/aP_aCIzat7YbEKHx4ssD",
  [PRODUCT_KEYS.ICARE]: "AW-964212897/SIG7CLr84PYbEKHx4ssD",
  [PRODUCT_KEYS.GIFT_CITY]: "AW-850515685/q3QXCOyk-o0cEOWtx5UD",
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: "AW-850515685/q3QXCOyk-o0cEOWtx5UD",
  [PRODUCT_KEYS.SMARTKID_ASSURE]: "AW-850515685/4jZ5CPH6iJoaEOWtx5UD",
  [PRODUCT_KEYS.PNG_WHOLELIFE]: "AW-850515685/F518CMbZ-vcbEOWtx5UD",
});

export const PRODUCT_TYPES = Object.freeze({
  termInsurancePlans: "term-insurance-plans",
  savingInsurancePlans: "saving-insurance-plans",
  retirementInsurancePlans: "retirement-insurance-plans",
  ulipInsurancePlans: "ulip-insurance-plans",
  traditional: "TRADITIONAL",
});

export const PRODUCT_CATEGORIES = Object.freeze({
  Term: "Term",
  Protection: "Protection",
  Saving: "Saving",
  Retirement: "Retirement",
  ULIP: "ULIP",
  Traditional: "TRADITIONAL",
});

export const PRODUCT_CHANNELS = Object.freeze({
  Protection: "Protection",
  Savings: "Savings",
  Retirement: "Retirement",
  Traditional: "TRADITIONAL",
});

export const PRODUCT_NAMES = Object.freeze({
  super: "ICICI PRU IPROTECT SUPER",
  iwish: "icici pru wish",
  Signature: "Signature",
  iciciPruSignatureAssure: "ICICI Pru Signature Assure",
  GiftPro: "GiftPro",
  iciciPruSignatureOnline: "ICICI Pru Signature Online",
  iciciSmartKid360: "ICICI Pru SmartKid 360 Plan",
  iciciPruGiftPro: "ICICI Pru GIFT Pro",
  iciciPruSignature: "ICICI PRU SIGNATURE",
  iciciPruPnG: "ICICI Pru Protect N Gain",
  iciciPruSaral: "SARALPENSION",
  iciciPruSaralPension: "ICICI Pru Saral Pension",
  iciciPruGpp: "ICICI PRU Guaranteed Pension Plan - Flexi",
  iciciPruGppQuote: "GUARANTEEDPENSIONPLANFLEXI",
  iciciSipPlus: "ICICI Pru Smart Insurance Plan Plus",
  iProtect: "iProtectSmart",
  iProtectSmartPlus: "ICICI PRU IPROTECT SMART PLUS",
  iProtectSmart: "ICICI Pru iProtect Smart",
  iProtectSmartNew: "ICICI Prudential iProtect Smart",
  iProtectSuper: "ICICI PRU IPROTECT SUPER",
  iProtectCare: "ICICI Pru iProtect Care",
  iProtectOptionIOnline: "ICICI Pru iProtect Option I Online",
  iProtectOptionIIOnline: "ICICI Pru iProtect Option II Online",
  icareSPI: "ICARE SP I",
  icareSPII: "ICARE SP II",
  icareRPI: "ICARE RP I",
  icareRPII: "ICARE RP II",
  savingSuraksha: "SAVING SURAKSHA",
  cashAdvantage: "CASH ADVANTAGE",
  iCareII: "ICICI Pru iCare II",
  immediateAnnuity: "Immediate annuity",
  easyRetirement: "IPru Easy Retirement",
  guaranteedWealthProtectorLP: "Guaranteed Wealth Protector LP",
  ipruEliteLifeII: "IPRU Elite Life II",
  ipruEliteWealthII: "IPRU Elite Wealth II",
  ipruWealthBuilderII: "IPRU Wealth Builder II",
  iProtectOptionI: "ICICI Pru iProtect Option I",
  termPlan: "Term Plan",
  smartLife: "ICICI Pru Smart Life",
  easyRetirementSP: "Easy Retirement SP",
  guaranteedWealthProtectorSP: "Guaranteed Wealth Protector SP",
  eliteLifeSP: "Elite Life SP",
  eliteWealthSP: "Elite Wealth SP",
  wealthBuilderSP: "Wealth Builder SP",
  smartKid: "SMARTKID WITH ICICI PRU SMART LIFE",
  UlipSignatureCalculator: "ULIP : Signature Calculator",
  UlipSignatureAssureCalculator: "ULIP : Signature Assure Calculator",
  SignatureAssured: "ICICI PRU SIGNATURE ASSURE",
  SmartKidAssure: "ICICI Pru SmartKid Assure",
  SipPlus: "ICICI Pru Smart Insurance Plan Plus",
  capitalGuaranteeII: "ICICI Prudential Signature Capital Guarantee II",
  Women_Health_plan: "Women Health Plan WISH Calculator",
  otc: "ICICI PRU SARAL JEEVAN BIMA",
  UnifiedPlan: "ICICI Pru Unified Plan",
  SignaturePension: "ICICI Pru Signature Pension",
  gold: "ICICI Pru Gold Plan Online",
  platinum: "ICICI Pru Platinum",
  gift: "ICICI Pru Guaranteed Income For Tomorrow",
  gpp: "ICICI Pru Guaranteed Pension Plan",
  iprop: "ICICI Pru iProtect smart Return of Premium",
  UlipSignatureAssureYoungsterCalculator: "ULIP : Signature Assure Calculator Youngster",
  GIFT_CITY: "ICICI Pru Global Wealth Multiplier Calculator",
  SignatureSecure: "ICICI Pru Signature Secure",
  globalWealthAccelerator: "ICICI Pru Global Wealth Accelerator",
  iciciSmartKidAssure: "ICICI Pru SmartKid Assure",
  SmartkidInvestmentPersona: "SmartKid Assure Calculator investment",
  SmartkidEducationPersona: "SmartKid Assure Calculator Education",
  SmartkidSWPPersona: "SmartKid Assure Calculator SWP",
  UnifiedSavingsPlan: "ICICI Pru Unified Savings Plan",
  pngWholeLife: "ICICI Pru Protect N Gain Whole Life",
  saveNGrow: "ICICI Pru Save and Grow",
  saralJeevanBima: "ICICI Pru Saral Jeevan Bima",
  futurePerfect: "ICICI Pru Future Perfect",
  lifeTimeClassic: "ICICI Pru Life Time Classic"
});

export const PAGE_CATEGORIES = Object.freeze({
  calculator: "calculator",
  appForm: "appForm",
});

export const PAGE_SUB_CATEGORIES = Object.freeze({
  calculator: "Landing page",
  appForm: "Appform Single Question Screen",
});

export const PAGE_STEPS = Object.freeze({
  calculator: "calculator",
  dataVerification: "dataVerification", // OTC
  quoteScreen: "quoteScreen",
  preQuoteScreen: "preQuoteScreen",
  appFormScreen: "appFormScreen",
});

export const LIGO_PAGES = Object.freeze({
  calculator: "Lead Page",
  quoteScreen: "Quote Page",
  appFormScreen: "Appform Page",
  fundAllocationScreen: "FundAllocation Page",
});

export const CALCULATOR_FORM_DATA_COOKIE = Object.freeze({
  ips: "ipsCalculatorData",
  smartKid: "smartKidCalculatorData",
  signatureUlip: "signatureUlipCalculatorData",
  giftPro: "giftProCalculatorData",
  png: "pngCalculatorData",
  gppFlexi: "gppCalculatorData",
  saralPension: "saralPensionCalculatorData",
  sipPlus: "sipPlusCalculatorData",
  default: "defaultCalculatorData",
  giftCity: "giftCityCalculatorData",
  globalWealthAccelerator: "globalWealthCalculatorData",
  smartKidAssure: "smartKidAssureCalculatorData",
});

export const RECENT_PRODUCT = {
  ips: "ipsPlus",
  "smart-kid": "SMARTKID",
  "signature-ulip": "Signature_ULIP_dynamic",
  "gift-pro": "GIFTPRO_dynamic",
  "ips-super": "SUPER",
  [PRODUCT_KEYS.PNG]: "PNG",
  [PRODUCT_KEYS.GPP_FLEXI]: "GPPFlexi_dynamic",
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: "ASSURE_dynamic",
  [PRODUCT_KEYS.GIFT_CITY]: "GIFT_CITY_dynamic",
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: "Global_Wealth_Accelerator_dynamic",
  [PRODUCT_KEYS.SMARTKID_ASSURE]: "SMART_KID_ASSURE",
  [PRODUCT_KEYS.SIGNATURE_YOUTH]: "SIP_PLUS",
  [PRODUCT_KEYS.SIGNATURE_SECURE]: "Signature_Secure",
  [PRODUCT_KEYS.PNG_WHOLELIFE]: "PNG_wholelife",
  [PRODUCT_KEYS.SMARTKID_360]: "Smart_kid_360",
  [PRODUCT_KEYS.GOLD]: "GOLD_dynamic",
};

/**
 * The product details for the calculator.
 *
 * @type {ProductDetailsArray}
 */
export const PRODUCT_DETAILS = Object.freeze([
  {
    key: "ips",
    name: PRODUCT_NAMES.iProtectSmartPlus,
    code: PRODUCT_CODES.iProtectSmartNew,
    shortName: "ipsPlus",
    category: PRODUCT_CATEGORIES.Term,
    channel: PRODUCT_CHANNELS.Protection,
    type: PRODUCT_TYPES.termInsurancePlans,
    pages: [
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-calculator-Persona",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-calculator-Persona",
        PageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-application-form",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-application-form",
        PageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.ICARE,
    name: PRODUCT_NAMES.iProtectCare,
    code: PRODUCT_CODES.iProtectCare,
    shortName: "icare",
    category: PRODUCT_CATEGORIES.Term,
    channel: PRODUCT_CHANNELS.Protection,
    type: PRODUCT_TYPES.termInsurancePlans,
    pages: [
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-calculator-Persona",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-calculator-Persona",
        PageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-application-form",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-application-form",
        PageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: "ips-super",
    name: PRODUCT_NAMES.super,
    code: PRODUCT_CODES.iProtectSuper,
    shortName: "ips_super",
    category: PRODUCT_CATEGORIES.Term,
    channel: PRODUCT_CHANNELS.Protection,
    type: PRODUCT_TYPES.termInsurancePlans,
    pages: [
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-calculator-Persona",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-calculator-Persona",
        PageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-application-form",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-application-form",
        PageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: "iwish",
    name: PRODUCT_NAMES.iwish,
    code: PRODUCT_CODES.iwish,
    shortName: "iwish",
    category: PRODUCT_CATEGORIES.Term,
    channel: PRODUCT_CHANNELS.Protection,
    type: PRODUCT_TYPES.termInsurancePlans,
    pages: [
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-calculator-Persona",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-calculator-Persona",
        PageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-application-form",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-application-form",
        PageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: "smart-kid",
    name: PRODUCT_NAMES.smartKid,
    code: PRODUCT_CODES.smartKid,
    shortName: "smart-kid",
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.smartKid,
        pageType: "top-ulips : icici-pru-smart-kid",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-smart-kid",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.smartKid,
        pageType: "top-ulips : icici-pru-smart-kid",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-smart-kid",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: "signature-ulip",
    name: PRODUCT_NAMES.Signature,
    code: PRODUCT_CODES.signature,
    shortName: "sign",
    dropOffShortName: PRODUCT_SHORT_NAME.signature,
    fullName: PRODUCT_NAMES.iciciPruSignature,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.UlipSignatureCalculator,
        pageType: "top-ulips : icici-pru-signature-ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature",
        pageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.smartKid,
        pageType: "top-ulips : icici-pru-signature-ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature",
        pageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.GIFTPRO,
    name: PRODUCT_NAMES.GiftPro,
    code: PRODUCT_CODES.giftPro,
    shortName: "gftp",
    dropOffShortName: PRODUCT_SHORT_NAME.giftPro,
    fullName: PRODUCT_NAMES.iciciPruGiftPro,
    category: PRODUCT_CATEGORIES.Traditional,
    channel: PRODUCT_CHANNELS.Traditional,
    type: PRODUCT_TYPES.traditional,
    pages: [
      {
        pageName: PRODUCT_NAMES.GiftPro,
        pageType: "top-ulips : icici-pru-signature",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.smartKid,
        pageType: "top-ulips : icici-pru-signature",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.PNG,
    name: PRODUCT_NAMES.iciciPruPnG,
    code: PRODUCT_CODES.png,
    shortName: PRODUCT_KEYS.PNG,
    dropOffShortName: PRODUCT_SHORT_NAME.png,
    fullName: PRODUCT_NAMES.iciciPruPnG,
    planType: PLAN_TYPES.LIFE,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.iciciPruPnG,
        pageType: "top-ulips : icici-pru-protect-n-gain",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-protect-n-gain",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.iciciPruPnG,
        pageType: "top-ulips : icici-pru-protect-n-gain",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-protect-n-gain",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.SIGNATURE_ASSURE,
    name: PRODUCT_NAMES.iciciPruSignatureAssure,
    code: PRODUCT_CODES.sigAssure,
    shortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.SIGNATURE_ASSURE],
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.UlipSignatureAssureCalculator,
        pageType: "top-ulips : icici-pru-signature-assure--ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature-assure-ulip",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.UlipSignatureAssureCalculator,
        pageType: "top-ulips : icici-pru-signature-assure--ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature-assure-ulip",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.GPP_FLEXI,
    name: PRODUCT_NAMES.iciciPruGpp,
    code: PRODUCT_CODES.gppFlexi,
    shortName: PRODUCT_KEYS.GPP_FLEXI,
    category: PRODUCT_CATEGORIES.Retirement,
    channel: PRODUCT_CHANNELS.Retirement,
    type: PRODUCT_TYPES.retirementInsurancePlans,
    pages: [
      // ask about this
      {
        pageName: PRODUCT_NAMES.iciciPruGpp,
        pageType: "top-ulips : icici-pru-gpp-flexi",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-gpp-flexi",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.iciciPruGpp,
        pageType: "top-ulips : icici-pru-gpp-flexi",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-gpp-flexi",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.SARAL_PENSION,
    name: PRODUCT_NAMES.iciciPruSaralPension,
    code: PRODUCT_CODES.saralPension,
    shortName: PRODUCT_KEYS.SARAL_PENSION,
    category: PRODUCT_CATEGORIES.Retirement,
    channel: PRODUCT_CHANNELS.Retirement,
    type: PRODUCT_TYPES.retirementInsurancePlans,
    pages: [
      // ask about this
    ],
  },
  {
    key: PRODUCT_KEYS.SIP_PLUS,
    name: PRODUCT_NAMES.iciciSipPlus,
    code: PRODUCT_CODES.sipPlus,
    shortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.SIP_PLUS],
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.UlipSignatureAssureCalculator,
        pageType: "top-ulips : icici-pru-signature-assure--ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature-assure-ulip",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.UlipSignatureAssureCalculator,
        pageType: "top-ulips : icici-pru-signature-assure--ulip",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature-assure-ulip",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.SMARTKID_ASSURE,
    name: PRODUCT_NAMES.iciciSmartKidAssure,
    code: PRODUCT_CODES.smartKidAssure,
    shortName: PRODUCT_KEYS.SMARTKID_ASSURE,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.SMARTKID_ASSURE,
        pageType: "top-ulips : icici-pru-ulip-smartkid-assure",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-ulip-smartkid-assure",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.SMARTKID_ASSURE,
        pageType: "top-ulips : icici-pru-ulip-smartkid-assure",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-ulip-smartkid-assure",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.OTC_SJB,
    name: PRODUCT_NAMES.otc,
    code: PRODUCT_CODES.otc,
    shortName: "ips super",
    category: PRODUCT_CATEGORIES.Term,
    channel: PRODUCT_CHANNELS.Protection,
    type: PRODUCT_TYPES.termInsurancePlans,
    planType: "OTC_SARAL_JEEVAN",
    pages: [
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-calculator-Persona",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-calculator-Persona",
        PageCategory: PAGE_CATEGORIES.calculator,
        PageSubCategory: PAGE_SUB_CATEGORIES.calculator,
      },
      {
        pageName: "protection : term-insurance-plans : iprotect-smart-term-insurance-application-form",
        pageType: "mid-term : iprotect-smart-term-insurance",
        subsection1: "term-insurance-plans",
        subsection2: "iprotect-smart-term-insurance-application-form",
        PageCategory: PAGE_CATEGORIES.appForm,
        PageSubCategory: PAGE_SUB_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.CAPITAL_GUARANTEE_II,
    fullName: PRODUCT_NAMES.capitalGuaranteeII,
    code: PRODUCT_CODES.capitalGuaranteeII,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.CAPITAL_GUARANTEE_II],
    category: PRODUCT_CATEGORIES.Traditional,
    type: PRODUCT_TYPES.traditional,
  },
  {
    key: PRODUCT_KEYS.SIGNATURE_PENSION,
    name: PRODUCT_NAMES.SignaturePension,
    code: PRODUCT_CODES.sigPension,
    shortName: PRODUCT_KEYS.SIGNATURE_PENSION,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Retirement,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      // ask about this
      {
        pageName: PRODUCT_NAMES.SignaturePension,
        pageType: "top-ulips : icici-pru-signature-pension",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-signature-pension",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.SignaturePension,
        pageType: "top-ulips : icici-pru-signature-pension",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-gpp-flexi",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.GOLD,
    fullName: PRODUCT_NAMES.gold,
    code: PRODUCT_CODES.gold,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.GOLD],
    category: PRODUCT_CATEGORIES.Traditional,
    type: PRODUCT_TYPES.traditional,
  },
  {
    key: PRODUCT_KEYS.PLATINUM,
    fullName: PRODUCT_NAMES.platinum,
    code: PRODUCT_CODES.platinum,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.PLATINUM],
    category: PRODUCT_CATEGORIES.Traditional,
    type: PRODUCT_TYPES.traditional,
  },
  {
    key: PRODUCT_KEYS.UNIFIED_PLAN,
    name: PRODUCT_NAMES.UnifiedPlan,
    code: PRODUCT_CODES.UnifiedPlan,
    shortName: PRODUCT_KEYS.UNIFIED_PLAN,
    dropOffShortName: PRODUCT_SHORT_NAME.UnifiedPlan,
    fullName: PRODUCT_NAMES.iciciPruPnG,
    planType: PLAN_TYPES.LIFE,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [],
  },
  {
    key: PRODUCT_KEYS.SMARTKID_360,
    name: PRODUCT_NAMES.iciciSmartKid360,
    code: PRODUCT_CODES.smartKid360,
    shortName: PRODUCT_KEYS.SMARTKID_360,
    category: PRODUCT_CATEGORIES.Traditional,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.traditional,
    fullName: PRODUCT_NAMES.iciciSmartKid360,
  },
  {
    key: PRODUCT_KEYS.IPROP,
    fullName: PRODUCT_NAMES.iprop,
    code: PRODUCT_CODES.iprop,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.IPROP],
    category: PRODUCT_CATEGORIES.Traditional,
    type: PRODUCT_TYPES.traditional,
    planType: PLAN_TYPES.IPROP,
  },
  {
    key: PRODUCT_KEYS.GPP,
    fullName: PRODUCT_NAMES.gpp,
    code: PRODUCT_CODES.gpp,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.GPP],
    category: PRODUCT_CATEGORIES.Retirement,
    type: PRODUCT_TYPES.retirementInsurancePlans,
  },
  {
    key: PRODUCT_KEYS.GIFT_CITY,
    name: PRODUCT_NAMES.GIFT_CITY,
    code: PRODUCT_CODES.giftCity,
    shortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.GIFT_CITY],
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.GIFT_CITY,
        pageType: "top-ulips : icici-pru-gift-city",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-gift-city",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR,
    name: PRODUCT_NAMES.globalWealthAccelerator,
    code: PRODUCT_CODES.wealthAccelerator,
    shortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR],
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.globalWealthAccelerator,
        pageType: "top-ulips : icici-pru-global-wealth-multiplier",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-global-wealth-multiplier",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
    ],
  },
  {
    key: PRODUCT_KEYS.SIGNATURE_SECURE,
    name: PRODUCT_NAMES.SignatureSecure,
    code: PRODUCT_CODES.sigSecure,
    shortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.SIGNATURE_SECURE],
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [],
  },
  {
    key: PRODUCT_KEYS.GIFT,
    fullName: PRODUCT_NAMES.gift,
    code: PRODUCT_CODES.gift,
    dropOffShortName: PRODUCT_SHORT_NAME[PRODUCT_KEYS.GIFT]?.toLocaleUpperCase(),
    category: PRODUCT_CATEGORIES.Traditional,
    type: PRODUCT_TYPES.traditional,
    planType: PLAN_TYPES.GIFT,
  },
  {
    key: PRODUCT_KEYS.SAVENGROW,
    fullName: PRODUCT_NAMES.saveNGrow,
  },
  {
    key: PRODUCT_KEYS.SARALJEEVANBIMA,
    fullName: PRODUCT_NAMES.saralJeevanBima,
  },
  {
    key: PRODUCT_KEYS.FUTUREPERFECT,
    fullName: PRODUCT_NAMES.futurePerfect,
  },
  {
    key: PRODUCT_KEYS.LTC,
    fullName: PRODUCT_NAMES.lifeTimeClassic,
  },
  {
    key: PRODUCT_KEYS.PNG_WHOLELIFE,
    name: PRODUCT_NAMES.pngWholeLife,
    code: PRODUCT_CODES.pngWholeLife,
    shortName: PRODUCT_KEYS.PNG_WHOLELIFE,
    category: PRODUCT_CATEGORIES.ULIP,
    channel: PRODUCT_CHANNELS.Savings,
    type: PRODUCT_TYPES.ulipInsurancePlans,
    pages: [
      {
        pageName: PRODUCT_NAMES.pngWholeLife,
        pageType: "top-ulips : icici-pru-protect-n-gain-whole-life",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-protect-n-gain-whole-life",
        pageCategory: PAGE_CATEGORIES.calculator,
      },
      {
        pageName: PRODUCT_NAMES.pngWholeLife,
        pageType: "top-ulips : icici-pru-protect-n-gain-whole-life",
        subsection1: "ulip-insurance-plans",
        subsection2: "icici-pru-protect-n-gain-whole-life",
        pageCategory: PAGE_CATEGORIES.appForm,
      },
    ],
  },
]);

export const PAGE_SECTIONS = Object.freeze({
  landingProd: "Calculator - landing page|Product Info",
  landingNeedHelp: "Calculator - landing page|talkToExpert",
  landingNeedHelpQuote: "Calculator - Quote Screen|talkToExpert",
  landing: "Calculator - landing page",
  benefit: "Calculator - landing page|Benefit Section",
  skipMandatory: "Calculator - landing page|skip mandatory",
  occupation: "Calculator - landing page|Occupation",
  calBenefit: "Calculator-Landing page|View Benefits",
  benefitSelected: "Calculator-Landing page|Benefit Selected",
  quickLinks: "Calculator - landing page|Quick Links",

  whatIs: "Calculator-Landing page|What Is",
  mythBusters: "Calculator-Landing page|Myth Busters",
  didYouKnow: "Calculator-Landing page|DidYouKnow",
  faq: "Calculator-Landing page|FAQs",
  keyTerminology: "Calculator-Landing page|KeyTerminology",
  grpEmp: "Calculator - landing page|Group Employee Discount",
  annualInc: "Calculator - landing page|Annual Income",
  faqSection: "Calculator-FAQS",
  illus: "Calculator - illustration",
  qukGuide: "Calculator - quickGuide",
  preQuote: "Calculator - Pre Quote Screen|lead",
  prelead: "Calculator - Pre QuoteScreen",
  skiplead: "Calculator - Pre Quote Screen|skipDetail",
  quoteScreen: "Calculator - Quote Screen|Plan",
  leadOptEmail: "Calculator - Quote Screen|emailsubmited",
  leadOptMob: "Calculator - Quote Screen|mobileSubmitted",
  viewBrkUp: "Calculator - Quote Screen|viewBreakUp",
  docList: "Calculator - Quote Screen|docList",
  lifeCover: "Calculator-QuoteScreen|LifeCover_Edit",
  taxSaving: "Calculator-QuoteScreen|TaxSavings",
  fundSelected: "Calculator-QuoteScreen|FundPerformance_Selected",
  fundOpen: "Calculator-QuoteScreen|FundPerformance_PopupOpen",
  close: "Calculator-QuoteScreen|close",
  gotIt: "Calculator-QuoteScreen|Got It",
  all: "Calculator-QuoteScreen|FundPerformance_all",
  equity: "Calculator-QuoteScreen|FundPerformance_Equity",
  debt: "Calculator-QuoteScreen|FundPerformance_Debt",
  balanced: "Calculator-QuoteScreen|FundPerformance_Balanced",
  fundQuoteScreen: "Calculator-QuoteScreen",
  editFunds: "Calculator-QuoteScreen|Edit Funds",
  investType: "Calculator-QuoteScreen|invest_type",
  proceed: "Calculator-QuoteScreen|proceed",
  fundSummary: "Calculator-QuoteScreen|FundAllocation_ViewFundSummary",
  fundPopup: "Calculator-QuoteScreen|FundSummary_PopupOpen",
  reset: "Calculator-QuoteScreen|reset",
  whatsApp: "Calculator-QuoteScreen|WhatsAppQuote_Selected",
  ebi: "Calculator-QuoteScreen|EBI_Downloaded",
  moreProducts: "Calculator - landing page|More_Products",

  disclaimer: "Calculator - landing page|Disclaimer",
  disclaimerQuote: "Calculator - quote page|Disclaimer",
  claimSettle: "Calculator - landing page|Claimsettlement",
  quote: "Calculator - Quote Screen",
  choose: "Calculator - landing page|whyChooseICICI",
  appform: "Appform",
  calFinal: "Calculator – Final",
  productInfo: "Calculator - landing page|Product Info",
  skipDetails: "Calculator - Pre Quote Screen|SkipDetail",
  talkToExpert: "Calculator - Call",
  riderAdded: "Calculator - Plan|Riders Added",
  riderRemoved: "Calculator - Plan|Riders Removed",
  planInfo: "Calculator - Plan Info",
  payoutOption: "Calculator - Plan|Payout Option",
  policyType: "Calculator - Plan|Policy Type",
  calProcedtoApp: "Calculator - Final",
  quotePlan: "Calculator - Quote Screen|Plan",
  leadPreQuote: "Calculator - Pre Quote Screen|lead",
  quickGuide: "Calculator - Guide",
  backQuote: "Calculator - Quote Screen|Back",
  preQuoteMob: "Calculator - Pre Quote Screen|Mobile",
  preQuoteEmail: "Calculator - Pre Quote Screen|Email",
  annualIncome: "Calculator - landing page|Annual Income",
  landingPage: "Calculator - landing page",
  leadOptproceed: "Calculator -  Quote Screen|PersonalDetail",
  mandatorylead: "Calculator - Quote Screen|lead",
  freeBenefits: "Calculator - Quote Screen|ViewFreeBenefit",
  brochureBtn: "Calculator - landing page|brochure",
  benefitBtn: "Calculator - landing page|benefits",
  faqBtn: "Calculator - landing page|FAQSelected",
  illustration: "Benefit illustration",
  calcBenefit: "Calculator-Landing page|Online Benefits",
  calcPlanBenefit: "Calculator-Landing page|Plan Benefits",
  calcRecommendedFor: "Calculator-Landing page|Recommended For",
  calcViewAllBenefit: "Calculator-Landing page|View All Benefits",
  calcWhy: "Calculator-Landing Page|Why Need Plan",
  calcPlanOptions: "Calculator-Landing Page| Plan Options",
  calcLoyalty: "Calculator-Landing page|Loyalty Bonus",
  calcPlanEligibility: "Calculator-Landing page|Plan Eligibility",
  fundPerformance: "Calculator-Landing page|Fund Performance",
  handyDocument: "Calculator-Landing page|Handy Document",
  callUsToday: "Calculator-Landing page|Call Us Today",
  claimForSure: "Calculator-Landing page|Claim For Sure",
  aadhaarVerification: "Calculator-Landing page|Aadhaar verification",
  footerBenefit: "Calculator - Landing Page|Floater-Benefits",
  howPlanWorks: "Calculator - Landing Page|Floater-How The Plan Works",
  footerFaq: "Calculator - Landing Page|Floater-FAQs",
  rider: "Calculator-QuoteScreen|Rider",
  education: "Calculator-Landing page|EducationQualification",
  floatingReturn: "Calculator-Landing page|Floater-Check Returns",
  proceedToApplication: "Calculator-QuoteScreen|ProceedToApplication",
  toggleButton: "Calculator-QuoteScreen|Toggle Button",
  brochureLanding: "Calculator - Landing Page|Brochure",
  brochureQuote: "Calculator - Quote Screen|Brochure",
  appFormPersonalDetails: "AppForm - PersonalPage|Question",
  appFormPersonalPageOtherPolicy: "AppForm - PersonalPage|OtherPolicy",
  appFormHealthDetails: "AppForm - HealthPage|Question",
  appFormPayoutAccDetail: "AppForm - PayoutPage|AccDetail",
  appFormPayoutDetails: "AppForm - PayoutPage|PayoutDetails",
  appFormSummaryPage: "AppForm - SummaryPage|SummaryDetails",
  appFormSummaryBasicInfoEdit: "AppForm - SummaryPage|BasicInformation",
  appFormSummaryPoliticalExposed: "AppForm - SummaryPage|PoliticallyExposedPerson",
  appFormSummaryCriminalOffenceRecord: "AppForm - SummaryPage|Criminal/CivilOffenceRecord",
  appFormSummaryThirdPartyPayment: "AppForm - SummaryPage|ThirdPartyPayment",
  appFormSummaryPageEIA: "AppForm - SummaryPage|eIA",
  appFormSummaryPageHealthDetails: "AppForm - SummaryPage|HealthDetails",
  appFormSummaryPagePayoutDetails: "AppForm - SummaryPage|PayoutDetails",
  appFormSummaryPageNominee: "AppForm - SummaryPage|Nominee",
  appFormSummaryPageBasicInformation: "AppForm - SummaryPage|BasicInformation",
  appFormSummaryPageContactDetails: "AppForm - SummaryPage|ContactDetails",
  appFormSummaryPagePreviousPolicyDetails: "AppForm - SummaryPage|PreviousPolicyDetails",
  appFormSummaryPageProposerDetails: "AppForm - SummaryPage|ProposerDetails",
  appFormSummaryPageProposerContactDetails: "AppForm - SummaryPage|ProposerContactDetails",
  appFormSummaryFATCA: "AppForm - SummaryPage|FATCA",
  appFormSummaryStayDetails: "AppForm - SummaryPage|StayDetails",
  appFormSummaryNriTravelDetails: "AppForm - SummaryPage|NriTravelDetails",
  appFormSummaryPageLifeAssuredCommunicationDetails: "AppForm - SummaryPage|LifeAssuredCommunicationDetails",
  appFormSummaryPageMwpa: "AppForm - SummaryPage|mwpa",
  appFormSummaryPageLaStayDetails: "AppForm - SummaryPage|LaStayDetails",
  appFormSummaryPageProceedPayment: "AppForm - SummaryPage|ProceedPayment",
  appFromTCAccepted: "AppForm - SummaryPage|T&CAccepted",
  appFromReview: "AppForm - ReviewSection",
});

export const COOKIE_NAME = {
  ips: "IPSPLUSCookie",
  "smart-kid": "SMARTKIDCookie",
  "signature-ulip": "SIGNATUREULIPCookie",
  "gift-pro": "GIFTPROCookie",
  [PRODUCT_KEYS.PNG]: "PNGCookie",
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: "SIGNATUREASSURECookie",
  [PRODUCT_KEY.gppFlexi]: "GPPFlexiCookie",
  [PRODUCT_KEYS.SARAL_PENSION]: "SARALPENSIONCookie",
  [PRODUCT_KEYS.SMARTKID_ASSURE]: "SMARTKIDASSURECookie",
  [PRODUCT_KEYS.SIP_PLUS]: "SIPPlusCookie",
  iwish: "WishCookie",
  [PRODUCT_KEYS.OTC_SJB]: "OTCCookie",
  [PRODUCT_KEYS.SMARTKID_360]: "SMARTKID360Cookie",
  [PRODUCT_KEYS.GIFT_CITY]: "GIFT_CITYCookie",
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: "GLOBALWEALTHCookie",
  [PRODUCT_KEYS.SIGNATURE_SECURE]: "SIGNATURESECURECookie",
};
export const NETCORE_NAME_IPS_DROP = "ips_calcdata_drop";
export const NETCORE_NAME_IPS_DROP_LANG = "ips_calcdata_lang_drop";

export const EVENT_NAME = {
  ENGLISH: {
    "smart-kid": {
      PAGENAME: "ICICI Life Smart Kid",
      EVENTNAME: "SmartKid_CalcData",
      GMG_NAME: "smartkid_calcdata",
      APPLICATION: {
        PAGENAME: "ICICI Life Smart Kid",
        EVENTNAME: "SmartKid_CalcData_Drop",
        GMG_NAME: "SmartKid_CalcData_drop",
      },
    },
    ips: {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData",
      GMG_NAME: "ips_calcdata",
      NETCORE_NAME: "ipsPlus_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Drop",
        GMG_NAME: "ips_calcdata_drop",
        NETCORE_NAME: "ipsPlus_calcdata_drop",
      },
      tenyears: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData",
        GMG_NAME: "ips_calcdata",
        NETCORE_NAME: "ipsplus10year_calcdata",
        APPLICATION: {
          PAGENAME: "Term Insurance Persona Calculator",
          EVENTNAME: "ipsplus10year_calcdata_drop",
          GMG_NAME: "ips_calcdata_drop",
          NETCORE_NAME: "ipsPlus_calcdata_drop",
        },
      },
    },
    "ips-super": {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData",
      GMG_NAME: "super_calcdata",
      NETCORE_NAME: "ipsSuper_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Drop",
        GMG_NAME: "super_calcdata_Drop",
        NETCORE_NAME: "ipsSuper_calcdata_drop",
      },
    },
    iwish: {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData",
      GMG_NAME: "iwish_calcdata",
      NETCORE_NAME: "iWish_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Drop",
        GMG_NAME: "super_calcdata_Drop",
        NETCORE_NAME: "iWish_calcdata_drop",
      },
    },
    "signature-ulip": {
      PAGENAME: "Signature Ulip",
      EVENTNAME: "Signature_CalcData",
      GMG_NAME: "signature_calcdata",
      NETCORE_NAME: "signature_calcdata",
      APPLICATION: {
        PAGENAME: "Signature Ulip",
        EVENTNAME: "Signature_CalcData_Drop",
        GMG_NAME: "signature_calcdata_drop",
        NETCORE_NAME: "signature_calcdata_drop",
      },
    },
    "gift-pro": {
      PAGENAME: "Gift Pro",
      EVENTNAME: "GiftPro_CalcData",
      GMG_NAME: "giftpro_calcdata",
      NETCORE_NAME: "giftpro_calcdata",
      APPLICATION: {
        PAGENAME: "Gift Pro",
        EVENTNAME: "GiftPro_CalcData_Drop",
        GMG_NAME: "giftpro_calcdata_drop",
        NETCORE_NAME: "giftpro_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.PNG]: {
      PAGENAME: "Protect N Gain",
      EVENTNAME: "PNG_CalcData",
      GMG_NAME: "png_calcdata",
      NETCORE_NAME: "png_calcdata",
      APPLICATION: {
        PAGENAME: "Protect N Gain",
        EVENTNAME: "PNG_CalcData_Drop",
        GMG_NAME: "png_calcdata_drop",
        NETCORE_NAME: "png_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SIGNATURE_ASSURE]: {
      PAGENAME: "Signature Assure",
      EVENTNAME: "SignatureAssure_CalcData",
      GMG_NAME: "signatureassure_calcdata",
      NETCORE_NAME: "signature_assure_calcdata",
      NETCORE_NAME_CUSTOM_SAVINGS_QUOTE: "Quote_Agent_SigAssure",
      APPLICATION: {
        PAGENAME: "Signature Assure",
        EVENTNAME: "SignatureAssure_CalcData_Drop",
        GMG_NAME: "signatureassure_calcdata_drop",
        NETCORE_NAME: "signature_assure_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.GPP_FLEXI]: {
      PAGENAME: "Guaranteed Pension Plan Flexi Calculator",
      EVENTNAME: "gpp_CalcData",
      GMG_NAME: "gpp_calcdata",
      NETCORE_NAME: "gppflexi_calcdata",
      APPLICATION: {
        PAGENAME: "Guaranteed Pension Plan Flexi Calculator",
        EVENTNAME: "gpp_CalcData_Drop",
        GMG_NAME: "gpp_calcdata_drop",
        NETCORE_NAME: "gppflexi_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SARAL_PENSION]: {
      PAGENAME: "Saral Pension",
      EVENTNAME: "saralPension_CalcData",
      GMG_NAME: "saral_calcdata",
      NETCORE_NAME: "saralpension_calcdata",
      APPLICATION: {
        PAGENAME: "Saral Pension",
        EVENTNAME: "saralPension_CalcData_Drop",
        GMG_NAME: "saralpension_calcdata_drop",
        NETCORE_NAME: "saralpension_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SIP_PLUS]: {
      PAGENAME: "Signature SIP Plus",
      EVENTNAME: "SignatureSipPlus_CalcData",
      GMG_NAME: "SIP_plus_calcdata",
      NETCORE_NAME: "SIP_plus_calcdata",
      APPLICATION: {
        PAGENAME: "Signature SIP Plus",
        EVENTNAME: "SignatureSipPlus_CalcData_Drop",
        GMG_NAME: "SIP_plus_calcdata_drop",
        NETCORE_NAME: "SIP_plus_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SMARTKID_ASSURE]: {
      PAGENAME: "SmartKid Assure",
      EVENTNAME: "smartkid_assure_calcdata",
      GMG_NAME: "smartkid_assure_calcdata",
      NETCORE_NAME: "smartkid_assure_calcdata",
      NETCORE_NAME_CUSTOM_SAVINGS_QUOTE: "Quote_Agent_SKA",
      APPLICATION: {
        PAGENAME: "SmartKid Assure",
        EVENTNAME: "smartkid_assure_calcdata_drop",
        GMG_NAME: "smartkid_assure_calcdata_drop",
        NETCORE_NAME: "smartkid_assure_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SMARTKID_360]: {
      PAGENAME: "SmartKid 360",
      EVENTNAME: "smartkid_360_calcdata",
      GMG_NAME: "smartkid_360_calcdata",
      NETCORE_NAME: "smartkid_360_calcdata",
      APPLICATION: {
        PAGENAME: "SmartKid 360",
        EVENTNAME: "smartkid_360_calcdata_drop",
        GMG_NAME: "smartkid_360_calcdata_drop",
        NETCORE_NAME: "smartkid_360_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.OTC_SJB]: {
      PAGENAME: PRODUCT_NAMES.otc,
      EVENTNAME: "OTC_CalcData",
      GMG_NAME: "otc_calcdata",
      NETCORE_NAME: "otc_calcdata",
      APPLICATION: {
        PAGENAME: PRODUCT_NAMES.otc,
        EVENTNAME: "OTC_CalcData_Drop",
        GMG_NAME: "otc_calcdata_drop",
        NETCORE_NAME: "otc_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.ICARE]: {
      PAGENAME: "Term Insurance IProtect Care Calculator",
      EVENTNAME: "ICARE_CalcData",
      GMG_NAME: "icare_calcdata",
      NETCORE_NAME: "icare_calcdata",

      APPLICATION: {
        PAGENAME: "Term Insurance IProtect Care Calculator",
        EVENTNAME: "ICARE_CalcData_Drop",
        GMG_NAME: "icare_calcdata_Drop",
        NETCORE_NAME: "icare_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SIGNATURE_PENSION]: {
      PAGENAME: "Signature Pension",
      EVENTNAME: "SignaturePension_CalcData",
      GMG_NAME: "signaturepension_calcdata",
      NETCORE_NAME: "signature_pension_calcdata",
      APPLICATION: {
        PAGENAME: "Signature Pension",
        EVENTNAME: "SignaturePension_CalcData_Drop",
        GMG_NAME: "signaturepension_calcdata_drop",
        NETCORE_NAME: "signature_pension_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.UNIFIED_PLAN]: {
      PAGENAME: "Uniified Plan",
      EVENTNAME: "UnifiedPlan_CalcData",
      GMG_NAME: "Unified_calcdata",
      NETCORE_NAME: "USP_calcdata",
      APPLICATION: {
        PAGENAME: "Uniified Plan",
        EVENTNAME: "UnifiedPlan_CalcData_Drop",
        GMG_NAME: "Unified_calcdata_drop",
        NETCORE_NAME: "USP_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.CAPITAL_GUARANTEE_II]: {
      PAGENAME: "Capital Guarantee II",
      EVENTNAME: "cg2_calcdata",
      GMG_NAME: "cg2_calcdata",
      NETCORE_NAME: "cg2_calcdata",
      APPLICATION: {
        PAGENAME: "Capital Guarantee II",
        EVENTNAME: "cg2_calcdata_drop",
        GMG_NAME: "cg2_calcdata_drop",
        NETCORE_NAME: "cg2_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.GIFT_CITY]: {
      PAGENAME: "Gift City Calculator",
      EVENTNAME: "GiftCity_CalcData",
      GMG_NAME: "giftcity_calcdata",
      NETCORE_NAME: "giftcity_calcdata",
      APPLICATION: {
        PAGENAME: "Gift City Calculator",
        EVENTNAME: "GiftCity_CalcData_Drop",
        GMG_NAME: "giftcity_calcdata_drop",
        NETCORE_NAME: "giftcity_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: {
      PAGENAME: "Global Wealth Accelerator Calculator",
      EVENTNAME: "GlobalWealthAccelerator_CalcData",
      GMG_NAME: "GWA_calcdata",
      NETCORE_NAME: "GWA_calcdata",
      APPLICATION: {
        PAGENAME: "Global Wealth Accelerator Calculator",
        EVENTNAME: "GlobalWealthAccelerator_CalcData_Drop",
        GMG_NAME: "GWA_calcdata_drop",
        NETCORE_NAME: "GWA_calcdata_drop",
      },
    },
    [PRODUCT_KEYS.SIGNATURE_SECURE]: {
      PAGENAME: "Signature Secure",
      EVENTNAME: "SignatureSecure_CalcData",
      GMG_NAME: "signaturesecure_calcdata",
      NETCORE_NAME: "signature_secure_calcdata",
      NETCORE_NAME_CUSTOM_SAVINGS_QUOTE: "",
      APPLICATION: {
        PAGENAME: "Signature Secure",
        EVENTNAME: "signature_secure_calcdata_drop",
        NETCORE_NAME: "signature_secure_calcdata_drop",
      },
    },
  },
  HINDI: {
    ips: {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData_Lang",
      GMG_NAME: "ips_calcdata_Lang",
      NETCORE_NAME: "ips_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData__Lang_Drop",
        GMG_NAME: "ips_calcdata__Lang_drop",
        NETCORE_NAME: NETCORE_NAME_IPS_DROP_LANG,
      },
      tenyears: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Lang",
        GMG_NAME: "ips_calcdata_Lang",
        NETCORE_NAME: "ipsplus10year_calcdata",
        APPLICATION: {
          PAGENAME: "Term Insurance Persona Calculator",
          EVENTNAME: "IPS_CalcData__Lang_Drop",
          GMG_NAME: "ips_calcdata__Lang_drop",
          NETCORE_NAME: NETCORE_NAME_IPS_DROP_LANG,
        },
      },
    },
    "ips-super": {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData",
      GMG_NAME: "super_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Drop",
        GMG_NAME: "ips_calcdata_drop",
      },
    },
    iwish: {
      PAGENAME: "Term Insurance Persona Calculator",
      EVENTNAME: "IPS_CalcData",
      GMG_NAME: "iwish_calcdata",
      APPLICATION: {
        PAGENAME: "Term Insurance Persona Calculator",
        EVENTNAME: "IPS_CalcData_Drop",
        GMG_NAME: "ips_calcdata_drop",
      },
    },
  },
};

export const STAMP_ALLOWED_PRODUCTS = [PRODUCT_KEYS.IPS, PRODUCT_KEYS.PNG];

export const PRODUCTS_LOGO = {
  ips: "/header/ips-plus-logo.jpg",
  icare: "/header/iprime-logo.svg",
  iwish: "/header/logo4.svg",
  "otc-sjb": "/header/sjb_logo.svg",
};

export const PRODUCT_TITLE = {
  ips: "ICICI Life IPROTECT SMART PLUS",
  icare: "ICICI Life IPROTECT CARE",
  iwish: "ICICI Life WISH",
};
